@use "~@optimizely/design-tokens/dist/scss/colors";

:host {
  height: 40px;
  --axiom-icon-size: 16px;

  ::slotted([slot='loading-text']) {
    padding: 12px 10px;
  }
}

.dropdown {
  height: inherit;
  position: relative;
  display: flex;
  color: #fff;
  background-color: transparent;
  transition: background-color 0.2s ease;
  align-items: center;
  transform: translateZ(0);

  &:hover:not(.dropdown--inactive) {
    cursor: pointer;
    background-color: colors.$brand-blue-base;
    color: colors.$tile-hover-text-title-color;
    * > .arrow {
      border-color: colors.$tile-hover-text-title-color;
    }
  }

  &:focus-within:not(.dropdown--inactive) {
    background-color: colors.$brand-blue-extra-light;
    color: colors.$tile-hover-text-title-color;
    * > .arrow {
      border-color: colors.$tile-hover-text-title-color
    }
  }

  &:focus-within:not(.dropdown--inactive) .menu {
    display: block;
    z-index: 999999;
  }

  .label {
    padding-right: calc(16px + var(--axiom-icon-size));  // 10px .label padding + width of .arrow + 6px between label and arrow
  }
}

.label {
  display: inline-block;
  padding: 12px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  &--loading {
    position: relative;
    opacity: 0.25;
    width: 100px;
    margin: 0 10px;
    height: 20px;
    top: -1px;
    background: #eee;
    background: linear-gradient(110deg, #9b9b9b 8%, #d5d5d5 18%, #9b9b9b 33%);
    border-radius: 5px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
  }
}
.menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 100%;
  max-width: 400px;
  margin: 0;
  padding: 0;
  border: 1px solid #cecece;
  list-style: none;
}

.arrow {
  display: inline-flex;
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  svg {
    width: var(--axiom-icon-size);
    height: var(--axiom-icon-size);
  }
}

a {
  display: block;
  text-decoration: none;
  color: #000;
  padding: 8px 10px;
  font-family: Arial;
  background-color: transparent;
  transition: background-color 0.2s ease;
  &:hover {
    background: #d5e1f6;
  }
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}
